import { NAP } from "@/lib/nap";

const ORG_ID = `${NAP.siteUrl}/#organization`;
const PROJECTS_PAGE_ID = `${NAP.siteUrl}/projects#projectspage`;
const LOGO_URL = `${NAP.siteUrl}/img/logo.svg`;
const OG_IMAGE = `${NAP.siteUrl}/img/og/siddhivinayak-group-og.jpg`;

const organization = {
  "@type": ["Organization", "RealEstateAgent"],
  "@id": ORG_ID,
  name: NAP.brand,
  alternateName: NAP.legalName,
  url: NAP.siteUrl,
  logo: LOGO_URL,
  telephone: NAP.phone,
  email: NAP.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.streetAddress,
    addressLocality: NAP.addressLocality,
    addressRegion: NAP.addressRegion,
    postalCode: NAP.postalCode,
    addressCountry: NAP.addressCountry,
  },
};

const projectsPage = {
  "@type": "CollectionPage",
  "@id": PROJECTS_PAGE_ID,
  url: `${NAP.siteUrl}/projects`,
  name: "Premium Residential Projects | Siddhivinayak Group",
  description:
    "Explore premium residential projects — apartments, villas, and gated communities across top Indian cities.",
  inLanguage: "en-IN",
  isPartOf: { "@id": `${NAP.siteUrl}/#website` },
  about: { "@id": ORG_ID },
  primaryImageOfPage: { "@type": "ImageObject", url: OG_IMAGE },
};

const breadcrumb = {
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: NAP.siteUrl },
    {
      "@type": "ListItem",
      position: 2,
      name: "Projects",
      item: `${NAP.siteUrl}/projects`,
    },
  ],
};

export const PROJECTS_LIST_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [organization, projectsPage, breadcrumb],
};